import { FC, useState } from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";

import AddButton from "@/components/AddButton";
import { SrOnly } from "@/components/Layout/Parts";
import { Table, TableContent, Th } from "@/components/Table";
import ToggableHeading from "@/components/ToggableHeading";
import { AddButtonHolder } from "./Notes";
import { ProductionSceneVoiceoverResource } from "@/types/resources";
import VoiceoversTableRow from "./VoiceoversTableRow";
import VoiceoverModal from "./VoiceoverModal";

const StyledTable = styled(Table)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayscale};
  th,
  td {
    font-size: 11px;
    vertical-align: top;
    &:nth-child(1) {
      width: 36%;
    }
    &:nth-child(2) {
      width: 16%;
    }
    &:last-child {
      width: 56px;
      position: relative;
      padding-right: 16px;
    }
  }
  td {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
  }
`;

const TableHolder = styled.div`
  margin-bottom: 56px;
`;

interface Props {
  voiceovers: ProductionSceneVoiceoverResource[][];
  scenes: number[];
}

const VoiceoversTable: FC<Props> = ({ voiceovers, scenes }) => {
  const [isOpen, setIsOpen] = useState(true);

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ToggableHeading
        heading="VOICEOVERS"
        onToggle={() => setIsOpen((prev) => !prev)}
        isOpen={isOpen}
      />
      {isOpen && (
        <TableHolder>
          <StyledTable $fixed>
            <thead>
              <tr>
                <Th>Scene Number & Element</Th>
                <Th>Assignee</Th>
                <Th>Start date & time</Th>
                <Th>Notes</Th>
                <Th>
                  <SrOnly>Actions</SrOnly>
                </Th>
              </tr>
            </thead>
            <tbody>
              <TableContent
                isLoading={false}
                colSpan={5}
                isError={false}
                hasData={true}
              >
                {voiceovers.map((sceneVoiceovers, index) =>
                  sceneVoiceovers.map((voiceover) => (
                    <VoiceoversTableRow
                      key={voiceover.id}
                      sceneIndex={index + 1}
                      voiceover={voiceover}
                    />
                  ))
                )}
              </TableContent>
            </tbody>
          </StyledTable>
          <AddButtonHolder>
            <AddButton onClick={() => setShowModal(true)}>
              Add voiceover
            </AddButton>
          </AddButtonHolder>
          <AnimatePresence>
            {!!showModal && (
              <VoiceoverModal
                scenes={scenes}
                onClose={() => setShowModal(false)}
              />
            )}
          </AnimatePresence>
        </TableHolder>
      )}
    </>
  );
};

export default VoiceoversTable;
